module.exports = __webpack_public_path__ + "media/images/workplace/patterns/11-db3a3f6f1a99f2bf90110b68fcdde7b5.png";